export default __webpack_public_path__ + "static/media/jeep.e04d5309.png";